import React from 'react';
import { Box, Typography, Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import ClinicHeaderItem from './ClinicHeaderItem';
import { formatDateHour2 } from '../utils/lib';
import ResourcesList from './ResourcesList';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSnackbar } from '../providers/SnackBarProvider';
import { handleError } from '../utils/lib';
import { useTranslation } from 'react-i18next';

function StudyItem({study, onDelete, pet, canEdit, config}) {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const { t } = useTranslation();
  const [openConfirm, setOpenConfirm] = React.useState(false);

  const handleEdit = () => {
    const state = {
      updateStudy: study,
      pet: pet,
    }

    //console.log(state);
    navigate('/main/edit-study', { state: state });
  }

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${import.meta.env.VITE_API_URL}pets_studies?id=${study.id}`,
        { withCredentials: true }
      );
      if (onDelete) {
        onDelete(study.id);
      }
    } catch (error) {
      handleError(error, snackbar);
    }
    setOpenConfirm(false);
  };

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const getTitle = () => {
    if (config?.vet?.id === study.vet.id) {
      return study.user.name;
    }
    return `${study.user.name} | ${study.vet.name}`;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <ClinicHeaderItem 
        title={getTitle()}
        subtitle={formatDateHour2(study.date, config)}
        age={study.age}
        thumbUrl={study.user.thumb_url}
        onEdit={canEdit ? handleEdit : undefined}
        onDelete={canEdit ? handleOpenConfirm : undefined}
      />

      <Box sx={{ mt: 2 }}>
        {/* <Typography variant="caption">
          Estudio
        </Typography> */}
        <Typography>
          {study.product?.name}
        </Typography>

        {study.notes && (
          <>
            <Typography variant="caption" sx={{ mt: 2, display: 'block' }}>
              {t('common.notes')}
            </Typography>
            <Typography>
              {study.notes}
            </Typography>
          </>
        )}
      </Box>

      {study.resources?.length > 0 && (
        <ResourcesList 
          resources={study.resources}
        />
      )}

      <Divider
        sx={{
          marginTop: 3,
          marginBottom: 1,
          backgroundColor: '#dadada',
          height: 1,
        }}
      />

      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
      >
        <DialogTitle>{t('common.confirmDeletion')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('layouts.confirmDeleteStudy')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="primary">
            {t('common.cancel')}
          </Button>
          <Button onClick={handleDelete} color="error" autoFocus>
            {t('common.delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default StudyItem; 